module.exports = __webpack_public_path__ + "img/orangeCircle.f143bd01.png";